/**
 * about.fandom.com front-end entry point.
 *
 * Scans the DOM for elements with class="js-module" and data-js-module="Name",
 * instantiates the matching module, and calls init().
 */

import 'lazysizes'

/* ── Module registry (static imports, no code splitting needed) ──────── */

import Animate from './modules/Animate'
import CardCarousel from './modules/CardCarousel'
import ContentCarousel from './modules/ContentCarousel'
import Counter from './modules/Counter'
import FandomButton from './modules/FandomButton'
import Gate from './modules/Gate'
import Grid from './modules/Grid'
import HalfBlock from './modules/HalfBlock'
import Header from './modules/Header'
import ImageCarousel from './modules/ImageCarousel'
import Language from './modules/Language'
import MarqueeImages from './modules/MarqueeImages'
import MouseFollow from './modules/MouseFollow'
import Popup from './modules/Popup'
import SignUpForm from './modules/SignUpForm'
import SliderBlog from './modules/SliderBlog'
import Video from './modules/Video'
import mailchimp from './modules/mailchimp'

const MODULES = {
  Animate,
  CardCarousel,
  ContentCarousel,
  Counter,
  FandomButton,
  Gate,
  Grid,
  HalfBlock,
  Header,
  ImageCarousel,
  Language,
  MarqueeImages,
  MouseFollow,
  Popup,
  SignUpForm,
  SliderBlog,
  Video,
  mailchimp,
}

/* ── Bootstrap ───────────────────────────────────────────────────────── */

function initModules() {
  const elements = document.getElementsByClassName('js-module')

  for (const el of elements) {
    const names = el.getAttribute('data-js-module')
    if (!names) continue

    for (const name of names.split(',')) {
      const trimmed = name.trim()
      const Mod = MODULES[trimmed]
      if (!Mod) {
        console.warn(`[app] Unknown module: "${trimmed}"`)
        continue
      }
      try {
        const instance = new Mod(el)
        instance.init()
      } catch (err) {
        console.error(`[app] Error initializing "${trimmed}":`, err)
      }
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initModules)
} else {
  initModules()
}

document.documentElement.classList.add('has-loaded')
document.documentElement.classList.remove('is-loading')
document.documentElement.classList.remove('no-js')
